import { render, staticRenderFns } from "./KerstmisMenu1.vue?vue&type=template&id=6672931a&"
import script from "./KerstmisMenu1.vue?vue&type=script&lang=js&"
export * from "./KerstmisMenu1.vue?vue&type=script&lang=js&"
import style0 from "./KerstmisMenu1.vue?vue&type=style&index=0&id=6672931a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports